const CONFIG_MIN_WIDTH = 440;

const sx = {
  wrapper: {
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    // Keep horizontal padding modest through laptop (lg=1280); roomy padding only at xl.
    px: { xs: 24, sm: 32, md: 40, lg: 48, xl: 100 },
    height: {
      xs: 'calc(100vh - 27px)',
      sm: 'calc(100vh - 51px)',
      md: 'calc(100vh - 47px)',
      lg: 'calc(100vh - 112px)',
    },
  },
  columns: {
    display: 'flex',
    gap: 16,
    flex: 1,
    minHeight: 0,
    minWidth: 0,
    overflow: 'hidden',
    width: '100%',
  },
  /**
   * Config keeps a hard floor. Preview prefers ~640px but may shrink — FitPreviewWidth
   * scales the A4 page so we never need a page-level horizontal scrollbar.
   */
  leftWrapper: {
    flex: '1 1 0',
    minWidth: CONFIG_MIN_WIDTH,
    minHeight: 0,
    overflowX: 'hidden',
    overflowY: 'auto',
    pt: 72,
    pb: 16,
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  rightWrapper: {
    // Prefer a readable preview width; shrink below that when the viewport is tight.
    flex: '1.2 1 640px',
    minWidth: 0,
    minHeight: 0,
    maxWidth: 960,
    pr: 8,
    overflowX: 'hidden',
    overflowY: 'auto',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  pdfWrapper: {
    mt: 72,
    mb: 64,
    width: '100%',
    maxWidth: '100%',
    overflow: 'hidden',
  },
  fileName: () => ({
    background: '#ffffff',
    border: '1px solid #e5e7eb',
    borderRadius: 8,
    padding: 16,
    width: '100%',
    maxWidth: 800,
    height: 64,
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    '& input': {
      border: 'none',
      outline: 'none',
      fontSize: 16,
      fontWeight: 600,
      flex: 1,
      minWidth: 0,
      width: '100%',
      lineHeight: 1.25,
      padding: 0,
      margin: 0,
      background: 'transparent',
    },
  }),
  actions: () => ({
    zIndex: 10,
    position: 'fixed',
    top: '28px',
    right: '144px',
    display: 'flex',
    gap: '4px',
    justifyContent: 'flex-end',
    marginTop: '8px',
  }),
  /** Icon-only below xl (laptop); full label from 1640px up. */
  actionButton: {
    minWidth: { xs: 40, xl: undefined },
    px: { xs: 10, xl: undefined },
    '& .MuiButton-startIcon': {
      margin: { xs: 0, xl: undefined },
    },
  },
  actionLabel: {
    display: { xs: 'none', xl: 'inline' },
  },
};

export default sx;
